
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class MSFScheduleEntryWriterService {

   public static draftAndPresentFirstMSFThroughCashfree(
           axiosInstance: AxiosInstance, input: ServerData.MSFScheduleEntryWebWriter.DraftAndPresentFirstMSFThroughCashfree$Input,
           f: (output: ServerData.MSFScheduleEntryWebWriter.DraftAndPresentFirstMSFThroughCashfree$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/msfscheduleentry/draft-and-present-first-m-s-f-through-cashfree',
            input.toJson()
        ).then((response) => ServerData.MSFScheduleEntryWebWriter.DraftAndPresentFirstMSFThroughCashfree$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

